<template lang="html">
  <div class="service-content">
    <loadData
      viewName="servicesList"
      :fetchData="servicesList"
      :fetchMethod="getServiceInfo"
      :controlPage="changePage"
      :page="pageIndex"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
    />
    <div v-show="isBottom" class="data-bottom"><span></span></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'

import loadData from '@/components/loadMore'

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      firstFetch: true,
      hasErr: false,
      uid: null,
      isBottom: false,
      workerCode: ''
    }
  },
  created() {
    this.uid = this.$route.params.uid || ''
    this.workerCode = this.$route.query.workerCode || ''
    this.getServiceInfo()
    this.$$title('育儿服务')
    this.$$loading(false)
    this.$$tracker('140101', '10000', '11021')
    this.$$share({
      desc: '专业的手艺人、细致的服务让您的孩子更健康让您的家庭更欢乐',
      title: '催乳、抚触、按摩、理胎发孩子王育儿平台为您服务'
    })
  },
  mounted() {},
  methods: {
    async getServiceInfo() {
      try {
        const serviceData = await this.$store.dispatch('getServiceInfoData', {
          uid: this.uid,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          workerCode: this.workerCode
        })

        if (serviceData.code * 1 === 1) {
          this.hasErr = false
          if (this.pageIndex !== 1) {
            this.firstFetch = false
          }
          if (this.pageIndex !== 1 && serviceData.data.length < this.pageSize) {
            this.isBottom = true
          }
        } else {
          this.firstFetch = false
          this.$$toast({
            message: serviceData.msg
          })
          this.hasErr = true
        }
      } catch (e) {
        this.firstFetch = false
        this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    }
  },
  components: {
    loadData,
    empty
  },
  computed: {
    ...mapState(['servicesList'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.service-content {
  padding-top: rem(20px);
  .serve-section {
    display: block;
    li {
      display: block;
      // margin-top: rem(20px);
      padding: rem(30px) rem(20px);
      // border-bottom: rem(1px) solid #EBEBEB;
      background: #ffffff;
      @include border(bottom, #e5e5e5);
      display: flex;
      img {
        display: block;
        width: rem(250px);
        height: rem(150px);
      }
      .info {
        flex: 1;
        // padding: 0 rem(20px);
        margin-left: rem(20px);
        overflow: hidden;
        .name {
          max-height: rem(46px);
          color: #121212;
          font-size: rem(32px);
          line-height: rem(46px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .txt {
          margin-bottom: rem(24px);
          color: #666666;
          font-size: rem(24px);
          line-height: rem(36px);
        }
        .price {
          margin-top: rem(4px);
          width: 100%;
          color: #ff397e;
          font-size: rem(36px);
          span {
            margin-right: rem(4px);
            font-size: rem(28px);
          }
        }
      }
    }
  }
  .data-bottom {
    position: relative;
    margin: 0 auto;
    width: rem(280px);
    height: rem(70px);
    background: #f4f4f4;
    span {
      display: block;
      width: rem(280px);
      height: rem(35px);
      @include border(bottom, #c6c6c6);
    }
  }
  .data-bottom::before {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: rem(-20px) 0 0 rem(-78px);
    width: rem(156px);
    height: rem(40px);
    content: '已经到底了';
    color: #999999;
    background: #f4f4f4;
    font-size: rem(24px);
    line-height: rem(40px);
    text-align: center;
    z-index: 10;
  }
}
</style>
